var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.note.title))]),_c('hr'),_vm._v(" "+_vm._s(_vm.note.published)+" - "+_vm._s(_vm.note.subject)+" "+_vm._s(_vm.note.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }